import { createContext, useCallback, useContext } from 'react';
const ChatReadOnlyContext = /*#__PURE__*/ createContext(false);
export const ChatReadOnlyProvider = ChatReadOnlyContext.Provider;
export const useChatReadOnly = ()=>useContext(ChatReadOnlyContext);
const ChatFeedbackContext = /*#__PURE__*/ createContext(null);
/**
 * Scopes card feedback to one chat surface. A ChatThread wraps its messages in
 * this provider with its own conversation's sender, so a DocumentWriteCard /
 * RecordWriteCard rendered inside it talks to THAT conversation — never a
 * different chat surface that happens to be mounted at the same time.
 */ export const ChatFeedbackProvider = ChatFeedbackContext.Provider;
/** Whether this surface can send a follow-up (a chat thread is wired). */ export const useChatFeedbackAvailable = ()=>useContext(ChatFeedbackContext) !== null;
/**
 * Returns a stable function that relays a card's follow-up to the owning chat.
 * When a ChatFeedbackProvider is present the message goes ONLY to that surface.
 *
 * There is NO fallback: this migration removed every legacy
 * `shanks-document-feedback` window listener, so a card rendered outside a wired
 * ChatThread has nowhere for its follow-up to go. Every card-hosting ChatThread
 * passes onFeedback today, so this only happens if a new chat surface forgets to
 * — in which case we warn loudly rather than drop the feedback in silence.
 */ export function useChatFeedback() {
    const scoped = useContext(ChatFeedbackContext);
    return useCallback((message)=>{
        if (scoped) {
            scoped(message);
            return;
        }
        console.warn('[useChatFeedback] card feedback fired with no ChatFeedbackProvider; the ' + 'follow-up was dropped. Pass onFeedback to the enclosing <ChatThread>.', message);
    }, [
        scoped
    ]);
}
